var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-success"},[_c('h1',{staticClass:"title"},[_vm._v("充值成功")]),_c('img',{staticClass:"image",attrs:{"src":require('@/assets/paySuccess.png')}}),_c('p',{staticClass:"message"},[_vm._v("请您回到工具刷新查看您的积分！")]),_c('p',{staticClass:"message"},[_vm._v("感谢您的支持！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }